module.exports = __webpack_public_path__ + "img/pic02.e291fe7c.png";